<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block applicationDefaut">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="综合" name="comprehensive">
          <comprehensive v-if="activeName === 'comprehensive'" @changePage="changePage"></comprehensive>
        </el-tab-pane>
        <el-tab-pane label="聚合" name="polymerization">
          <polymerization
            v-if="activeName === 'polymerization'"
            :polymerizationData="polymerizationData"
            @destroyedFn="destroyedFn"
          ></polymerization>
        </el-tab-pane>
      </el-tabs>
    </Content>
  </Layout>
</template>
<script>
import Comprehensive from './components/comprehensive'
import Polymerization from './components/polymerization'
export default {
  name: 'applicationDefault',
  components: { Comprehensive, Polymerization },
  data() {
    return {
      activeName: 'comprehensive',
      polymerizationData: {}
    }
  },
  created() {
    const { name } = this.$route.query
    if (name) {
      this.activeName = name
    }
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event)
    },
    changePage(info) {
      this.activeName = 'polymerization'
      this.polymerizationData = info
    },
    destroyedFn(info) {
      this.polymerizationData = {}
    }
  }
}
</script>
